/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Legal_Entity_DicInputs */

const cs_auth_signup_legal_entity_dic = /** @type {(inputs: Auth_Signup_Legal_Entity_DicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DIČ`)
};

const en_auth_signup_legal_entity_dic = /** @type {(inputs: Auth_Signup_Legal_Entity_DicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DIČ`)
};

/**
* | output |
* | --- |
* | "DIČ" |
*
* @param {Auth_Signup_Legal_Entity_DicInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_signup_legal_entity_dic = /** @type {((inputs?: Auth_Signup_Legal_Entity_DicInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Legal_Entity_DicInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_signup_legal_entity_dic(inputs)
	return cs_auth_signup_legal_entity_dic(inputs)
});